export const TABLE_REMINDERS_NAME_KEY = 'name';
export const TABLE_REMINDERS_TYPE_KEY = 'type';
export const TABLE_REMINDERS_CUSTOMER_KEY = 'customer';
export const TABLE_REMINDERS_STATUS_KEY = 'status';
export const TABLE_REMINDERS_CREATED_AT_KEY = 'createdAt';
export const TABLE_REMINDERS_CREATED_BY_KEY = 'createdBy';
export const TABLE_REMINDERS_MODIFIED_AT_KEY = 'modifiedAt';
export const TABLE_REMINDERS_MODIFIED_BY_KEY = 'modifiedBy';
export const TABLE_REMINDERS_LICENCE_NUMBER_KEY = 'licenceNumber';
export const TABLE_REMINDERS_VEHICLE_NAME_KEY = 'vehicleName';
export const TABLE_REMINDERS_CONFIRMABLE_KEY = 'confirmable';
export const TABLE_REMINDERS_NOTIFICATION_SETTINGS_KEY = 'notificationSettings';
export const TABLE_REMINDERS_NEXT_DATE_KEY = 'nextDate';
export const TABLE_REMINDERS_EARLY_NEXT_DATE_KEY = 'earlyNextDate';
export const TABLE_REMINDERS_EARLY_NEXT_MILEAGE_KEY = 'earlyNextMileage';
export const TABLE_REMINDERS_NEXT_MILEAGE_KEY = 'nextMileage';

export const REMINDERS_TABLE_KEY = 'v1/reminders';
export const REMINDERS_TABLE_SETTINGS = 'reminders';
export const REMINDERS_QUERY_KEY = 'remindersData';
export const REMINDERS_TYPE_DATE = 'date';
export const REMINDERS_TYPE_MILEAGE = 'mileage';
export const REMINDERS_TYPE_DATE_AND_MILEAGE = 'dateAndMileage';
export const API_REMINDERS = '/v1/reminders';

export const REMINDERS_LOGS_TABLE_KEY = 'v1/reminders/logs';
export const REMINDERS_LOGS_SETTINGS_KEY = 'reminders_sent_logs';

export const REMINDERS_LOGS_SENT_AT_KEY = 'sentAt';
export const REMINDERS_LOGS_CUSTOMER_KEY = 'customer';
export const REMINDERS_LOGS_REMINDER_KEY = 'reminder';
export const REMINDERS_LOGS_RECIPIENT_KEY = 'recipient';
export const REMINDERS_LOGS_TYPE_KEY = 'type';
export const REMINDERS_LOGS_MESSAGE_KEY = 'message';

export const REMINDERS_FORM_DEFAULT_VALUES = {
  type: undefined,
  customerId: undefined,
  name: '',
  confirmable: false,
  text: '',
  dateInterval: {
    scheduleAt: undefined,
    notifyBeforeInterval: undefined,
    repeatInterval: undefined,
    repeatMode: 'no-repeat',
    notifyBeforeMode: 'no-notify',
  },
  mileageInterval: {
    vehicleId: undefined,
    odometer: '',
    scheduleAt: 0,
    notifyBeforeThreshold: undefined,
    repeatInterval: undefined,
    repeatMode: 'no-repeat',
  },
  recipients: {
    persons: [],
    allAssignedDrivers: false,
    emails: [],
  },
  filters: {
    blacklistedUsers: [],
  },
  recurrenceSettings: {
    period: undefined,
    nextDate: '',
  },
  notificationSettings: [] as string[],
};

export const QUERY_KEYS = {
  EDIT_DATA: 'reminders-edit-data',
  USERS_DATA: 'reminders-users-data',
  VALIDATION_DATA: 'reminders-validation-data',
  VEHICLE_OPTIONS: 'reminders-vehicle-options',
} as const;

export const FORM_VALUES = {
  ENABLED: '1',
  DISABLED: '0',
  TRUE: 'true',
  FALSE: 'false',
} as const;

// Max validation constants for repeat intervals
// Primary limit: 4 years maximum
export const MAX_REPEAT_INTERVAL_YEARS = 4;
// Calculated from years: 4 years * 12 months = 48 months
export const MAX_REPEAT_INTERVAL_MONTHS = MAX_REPEAT_INTERVAL_YEARS * 12;
// Calculated from years: 4 years * 365.25 days (accounting for leap years) ≈ 1461 days
// export const MAX_REPEAT_INTERVAL_DAYS = Math.floor(MAX_REPEAT_INTERVAL_YEARS * 365.25);
export const MAX_REPEAT_INTERVAL_DAYS = 1500;

export const REMINDER_STATUS_PENDING = 'PENDING' as const;
export const REMINDER_STATUS_PENDING_CONFIRM = 'PENDING_CONFIRM' as const;
export const REMINDER_STATUS_PROCESSED = 'PROCESSED' as const;
export const REMINDER_STATUS_FAILED = 'FAILED' as const;
